export default __webpack_public_path__ + "static/media/icon-calendar.54f2825c.svg";